module.exports = __webpack_public_path__ + "media/images/icons/lock-locked-e901935e1ec59ff8b6829681ba743948.svg";